import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { selectPhotosList } from '../../../shopping-cart-back/actions/selector';
import { ShoppingCartState } from '../../../shopping-cart-back/actions/standalone';
import { ZalamoObject } from '../../../../../zalamo/pipes/names/graphql';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { map } from 'rxjs/operators';
import { BehaviorSubject, combineLatest, Observable } from 'rxjs';
import { selectMatchList } from '../../../../../../../../public-session/src/app/ngrx/publis-session-state.selectors';
import { translationProvider } from '@ui/nls/translations/translate.directive';
import { ENFORCE_SCREEN_PROTECTION_IN_NATIVE_APP } from '@ui/zalamo-dialog/screen-protection.token';

@Component({
    selector: 'lib-swap-photo-in-the-product',
    templateUrl: './swap-photo-in-the-product.component.html',
    styleUrls: ['./swap-photo-in-the-product.component.scss'],
    providers: [translationProvider('productFront')],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SwapPhotoInTheProductComponent implements OnInit {
  static readonly [ENFORCE_SCREEN_PROTECTION_IN_NATIVE_APP] = true;
  photos$ = this.store.pipe(select(selectPhotosList));
  photoId = '';
  @Input() photosSelectedByPhotographer: Array<{ photoId: string }>;
  @Output() swapPhoto = new EventEmitter();
  @Output() closeDialog = new EventEmitter();
  @Input() context: ZalamoObject = null;
  @Input() contextId: string = null;
  photoId$ = new BehaviorSubject<string>('');
  photosList$: Observable<
    Array<{
      height: number;
      width: number;
      photoGroupHasPhotoId: string;
      photoId: string;
      photoGroupId: string;
      check: boolean;
    }>
  > = combineLatest([
    this.photos$,
    this.photoId$,
    this.store.select(selectMatchList),
  ]).pipe(
    map(([photos, changePhotoId, searchMatch]) => {
      const photosList: Array<{
        height: number;
        width: number;
        photoGroupHasPhotoId: string;
        photoId: string;
        photoGroupId: string;
        check: boolean;
      }> = [];
      this.photosSelectedByPhotographer
        .filter(({ photoId }) => {
          if (searchMatch === null) {
            return true;
          }
          return (
            changePhotoId.includes(photoId) ||
            this.photoId.includes(photoId) ||
            searchMatch.includes(photoId)
          );
        })
        .forEach(({ photoId }) => {
          photosList.push({
            ...photos
              .find((x) => x.photos.find((y) => y.photoId === photoId))
              .photos.find((y) => y.photoId === photoId),
            check: false,
          });
        });
      if (this.photoId.length > 0) {
        photosList.find((value1) => value1.photoId === this.photoId).check =
          true;
      }
      if (changePhotoId.length > 0) {
        photosList.find((value1) => value1.photoId === changePhotoId).check =
          true;
      }
      return photosList;
    }),
  );

  gridItemSize = this.screenObserver.isMatched(Breakpoints.Handset)
    ? Math.floor(screen.width - 4) / 3
    : 400;
  isPhonePortrait$ = this.screenObserver
    .observe([Breakpoints.HandsetPortrait, Breakpoints.HandsetLandscape])
    .pipe(map(({ matches }) => matches));

  constructor(
    private screenObserver: BreakpointObserver,
    private store: Store<{ shoppingCart: ShoppingCartState }>,
  ) {}

  ngOnInit(): void {}

  checkPhoto(photoId) {
    this.photoId = photoId;
    this.photoId$.next(photoId);
  }
}
